__turbopack_context__.v({
  "className": "P8Pb4W_className",
  "variable": "P8Pb4W_variable",
});
